import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-wizard-form-input',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './wizard-form-input.component.html',
  styleUrl: './wizard-form-input.component.css',
  animations: [
    trigger('opacityAnimation', [
      transition(':enter', [
        style({ opacity: 0.3 }),
        animate('600ms ease-in-out', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class WizardFormInputComponent {
  @Input() inputSettings!: {
    isSmall: boolean;
    label: string;
    id: string;
    type: string;
    value: string | number | undefined;
    inputFunction: (event: any) => void;   
    formPageName?: string;
    validationType?: string;
  };

  formatDate(event: any): void {
    let inputValue = event.target.value;

    // Remove non-digit characters
    inputValue = inputValue.replace(/\D/g, '');

    // Add slashes after the appropriate number of digits
    if (inputValue.length > 2 && inputValue.length <= 4) {
      inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
    } else if (inputValue.length > 4) {
      inputValue =
        inputValue.slice(0, 2) +
        '/' +
        inputValue.slice(2, 4) +
        '/' +
        inputValue.slice(4, 8);
    }

    // Set the formatted value back to the input
    event.target.value = inputValue;
  }
}
